import React from 'react';
import DeprecationTracker from './DeprecationTracker';

export default function LMSDeprecationTracker() {
  return (
    <DeprecationTracker apiName="lms" apiDisplayName="LMS" />
  );
}
